import { render, staticRenderFns } from "./Pfts.vue?vue&type=template&id=7fede98e&scoped=true"
import script from "./Pfts.vue?vue&type=script&lang=js"
export * from "./Pfts.vue?vue&type=script&lang=js"
import style0 from "./Pfts.vue?vue&type=style&index=0&id=7fede98e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fede98e",
  null
  
)

export default component.exports